// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/plus-home.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aioption-container {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  cursor: hand;
  cursor: -moz-pointer;
}

.aioption-container.disable {
  pointer-events: none;
  opacity: 0.4;
}

.aioption-content {
  margin-bottom: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px 16px 16px;
  gap: 24px;
  width: 492px;
  height: 92px;
  background: #fefefe;
  border: 1px solid #e8ecef;
  border-radius: 12px;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  cursor: pointer;
  cursor: hand;
  cursor: -moz-pointer;
  position: relative;
}

.aioption-content .first-column {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
}

.aioption-content .first-column .content-left,
.aioption-content .first-column .generate-img {
  width: 60px;
  height: 60px;
}

.aioption-content .first-column .plusIcon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  width: 24px;
  height: 24px;
  margin-left: 10px;
  margin-right: 10px;
}

.aioption-content:hover {
  box-shadow: 0px 0px 16px 4px rgba(0, 0, 0, 0.04), 0px 33px 24px -17px rgba(0, 0, 0, 0.12);
}

.second-column {
  width: 70%;
  text-align: left;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/Components/AIOption/aioption.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;EACA,YAAA;AACF;;AAGA;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAAF;;AAGA;;EAEE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,6DAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yFAAA;AAAF;;AAGA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;AAAF","sourcesContent":[".aioption-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  cursor: hand;\n  cursor: -moz-pointer;\n}\n\n.aioption-container.disable {\n  pointer-events: none;\n  opacity: 0.4;\n\n}\n\n.aioption-content {\n  margin-bottom: 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 16px 24px 16px 16px;\n  gap: 24px;\n  width: 492px;\n  height: 92px;\n  background: #fefefe;\n  border: 1px solid #e8ecef;\n  border-radius: 12px;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: space-between;\n  cursor: pointer;\n  cursor: hand;\n  cursor: -moz-pointer;\n  position: relative;\n}\n\n.aioption-content .first-column {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n}\n\n.aioption-content .first-column .content-left,\n.aioption-content .first-column .generate-img {\n  width: 60px;\n  height: 60px;\n}\n\n.aioption-content .first-column .plusIcon {\n  background: url(\"../../Assets/Images/plus-home.svg\") no-repeat;\n  width: 24px;\n  height: 24px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.aioption-content:hover {\n  box-shadow: 0px 0px 16px 4px rgba(0, 0, 0, 0.04), 0px 33px 24px -17px rgba(0, 0, 0, 0.12);\n}\n\n.second-column {\n  width: 70%;\n  text-align: left;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
